@if ($agreement()) {
  <kendo-card class="summary-card" width="auto">
    <kendo-card-body>
      <ng-content />
    </kendo-card-body>
  </kendo-card>
}
